const TIPO_MENSAJE = {
  1: 'texto',
  2: 'imagen',
  3: 'audio',
  4: 'pdf',
  5: 'sticker',
  6: 'video',
}

const MEDIA_BASE_INBI = 'https://escuelakpi.club/imagenes-whatsapp/'

function limpiarTelefono (usuario) {
  return String(usuario || '').replace('whatsapp:', '').replace('+52', '').trim()
}

function urlMediaAbsoluta (media) {
  const raw = String(media || '').trim()
  if (!raw) return null
  if (/^https?:\/\//i.test(raw)) return raw
  return MEDIA_BASE_INBI + raw.replace(/^\//, '')
}

function normalizarMensaje (m) {
  const tipo = TIPO_MENSAJE[m.type] || (m.type === 'sticker' ? 'sticker' : 'texto')
  const esAgente = Number(m.mio) === 1

  return {
    fecha: m.fecha_creacion || m.fecha || null,
    emisor: esAgente ? 'agente' : 'cliente',
    tipo,
    texto: m.mensaje || '',
    media: urlMediaAbsoluta(m.MediaUrl0),
    id: m.idmensajes || m.messageSid || null,
  }
}

export function buildConversacionTwilioIA ({
  origen,
  chat,
  mensajes,
  alumno,
  asignacion,
  analysisIA,
  estadoOrquestadorV2 = null,
  traceTurnosV2 = null,
  diagnosticoV2 = null,
  debugMeta = null,
}) {
  const lista = Array.isArray(mensajes) ? mensajes : []

  return {
    meta: {
      origen: origen || 'twilio',
      exportado_en: new Date().toISOString(),
      linea_twilio: (chat && chat.numeroTwilio) || null,
      contacto: limpiarTelefono(chat && chat.usuario),
      nombre_chat: (chat && chat.nombre) || null,
      folio: (chat && chat.folio) || null,
      ciudad: (chat && chat.city) || null,
      sucursal: (chat && chat.sucursal) || null,
      usuario_asignado: (chat && chat.usuario_asignado) || null,
      id_prospecto: (chat && chat.idprospectos) || null,
      etiqueta: (chat && chat.etiqueta) || null,
      total_mensajes: lista.length,
    },
    prospecto: alumno ? {
      nombre: alumno.nombre_completo || alumno.nombre || null,
      folio: alumno.folio || null,
      telefono: alumno.telefono || alumno.celular || null,
      plantel: alumno.plantel || null,
      etapa: alumno.etapa || null,
    } : null,
    asignacion: asignacion || null,
    mensajes: lista.map(normalizarMensaje),
    analysis_ia: analysisIA || null,
    // Observabilidad V2 (diagnóstico). Vacío si el peer aún no tiene sesión debug.
    estado_orquestador_v2: estadoOrquestadorV2 || null,
    trace_turnos_v2: Array.isArray(traceTurnosV2) ? traceTurnosV2 : [],
    diagnostico_v2: diagnosticoV2 || null,
    debug_meta: debugMeta || null,
  }
}

export async function copiarTextoPortapapeles (texto) {
  const valor = String(texto || '').trim()
  if (!valor) throw new Error('Sin contenido para copiar')

  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(valor)
    return
  }

  const input = document.createElement('textarea')
  input.value = valor
  input.setAttribute('readonly', '')
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
}

export function descargarJson (jsonStr, nombreArchivo) {
  const blob = new Blob([jsonStr], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = nombreArchivo
  a.click()
  URL.revokeObjectURL(url)
}
